export default __webpack_public_path__ + "static/media/K2D-Medium.1c858673.ttf";